// NOTE: modified version from https://usehooks.com/useWindowSize/
import { useEffect, useState } from 'preact/hooks';

export default () => {
	const [windowSize, setWindowSize] = useState({
		width: null,
		height: null
	});

	let resizeTimer = null;

	useEffect(() => {
		function handleResize() {
			clearTimeout(resizeTimer);

			resizeTimer = setTimeout(() => {
				setWindowSize({
					width: window.innerWidth,
					height: window.innerHeight
				});
			}, 100);
		}

		window.addEventListener('resize', handleResize);
		handleResize();

		return () => window.removeEventListener('resize', handleResize);
	}, []);


	return windowSize;
};
